export const league = [
  {
    number: 'L101',
    hasModel: false
  },
  {
    number: 'L102',
    hasModel: false
  },
  {
    number: 'L103',
    hasModel: false
  },
  {
    number: 'L104',
    hasModel: false
  },
  {
    number: 'L105',
    hasModel: false
  },
  {
    number: 'L106',
    hasModel: false
  },
  {
    number: 'L107',
    hasModel: false
  },
  {
    number: 'L108',
    hasModel: false
  },
  {
    number: 'L109',
    hasModel: false
  },

]